import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/spotxlogo.png" alt="spotx Logo" className="footer-logo" />
            <p className="footer-tagline">
              spotx – Dein Weg zu fairen Belohnungen durch Kampagnen-Engagement. 
              Fair, transparent und einfach.
            </p>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-title">App</h4>
              <a href="#features">Features</a>
              <a href="#how-it-works">So funktioniert's</a>
              <a href="#screenshots">Screenshots</a>
              <a href="#rewards">Belohnungen</a>
            </div>
            <div className="footer-column">
              <h4 className="footer-title">Support</h4>
              <a href="#faq">FAQ</a>
              <a href="#cta">Download</a>
              <a href="#">Kontakt</a>
            </div>
            <div className="footer-column">
              <h4 className="footer-title">Rechtliches</h4>
              <Link to="/datenschutz">Datenschutz</Link>
              <a href="#">Impressum</a>
              <a href="#">AGB</a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} spotx. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
